import { BaseElement } from './base.js';

const supportsFormAssociated = (() => {
	if (typeof window === 'undefined' || typeof document === 'undefined') return true;
	if (typeof customElements === 'undefined' || typeof HTMLElement === 'undefined') return true;
	const isFirefox = typeof navigator !== 'undefined' && /firefox\//i.test(navigator.userAgent);
	if (isFirefox) return false; // Firefox still throws NotSupportedError for FACE elements.
	if (typeof HTMLElement.prototype.attachInternals !== 'function' || typeof window.ElementInternals === 'undefined') {
		return false;
	}
	try {
		const probeTag = `face-probe-${Math.random().toString(36).slice(2)}`;
		class FACEProbe extends BaseElement {
			static formAssociated = true;
			constructor() {
				super();
				this.attachInternals();
			}
		}
		customElements.define(probeTag, FACEProbe);
		document.createElement(probeTag);
		return true;
	} catch (err) {
		return false;
	}
})();

let canAttachInternals = true;
let loggedAttachInternalsFailure = false;

// Mixin to add form-association (ElementInternals) to BaseElement

export const FormAssociated = (Base) => class extends Base {
	static formAssociated = supportsFormAssociated;

	constructor(...args) {
		super(...args);
		this._internals = null;
		if (!supportsFormAssociated) return;
		if (canAttachInternals && typeof this.attachInternals === 'function') {
			try {
				this._internals = this.attachInternals();
			} catch (err) {
				canAttachInternals = false; // Firefox exposes attachInternals but throws; fall back silently.
				this._internals = null;
				if (!loggedAttachInternalsFailure) {
					loggedAttachInternalsFailure = true;
					console.warn('[omni] attachInternals() is not supported; falling back to hidden inputs.', err);
				}
			}
		}
	}

	// Call this when your value changes
	_updateFormValue(value) {
		if (!this._internals) return;
		this._internals.setFormValue(value);
	}

	get form() { return this._internals?.form ?? null; }
	get name() { return this.getAttribute('name') ?? ''; }
	get type() { return this.localName; } // for compatibility
	get validity() { return this._internals?.validity ?? {}; }
	get validationMessage() { return this._internals?.validationMessage ?? ''; }
	get willValidate() { return this._internals?.willValidate ?? false; }

	checkValidity() { return this._internals?.checkValidity() ?? true; }
	reportValidity() { return this._internals?.reportValidity() ?? true; }
	setValidity(flags, msg, anchor) { this._internals?.setValidity(flags, msg, anchor); }
};
